var render = function render(){var _vm=this,_c=_vm._self._c;return _c('notifications',{attrs:{"position":_vm.isMobileDevice ? 'top right' : 'bottom right',"width":_vm.isMobileDevice ? '100%' : '25%'}})
}
var staticRenderFns = []

export { render, staticRenderFns }